var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegacySystemTaxVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7293 52.2592C11.955 50.8895 6.95652 50.1986 2.10765 49.5657C1.06328 49.433 0.0936464 50.1735 0.0190483 51.2167C-0.130148 52.2607 0.61627 53.2155 1.58605 53.3481C6.28572 53.9575 11.1342 54.6095 15.6846 55.928C16.6544 56.214 17.6992 55.6253 17.9976 54.6125C18.296 53.6006 17.6991 52.5459 16.7293 52.2592Z",
    fill: "#0E0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2014 32.8416C23.5178 24.826 14.8645 17.8421 7.33005 9.61146C6.65867 8.84276 5.4651 8.80158 4.71912 9.51918C3.97314 10.2375 3.89883 11.4455 4.64481 12.2142C12.1792 20.4685 20.8326 27.4752 28.5162 35.5145C29.2622 36.2649 30.4555 36.2756 31.2014 35.5374C31.8728 34.8 31.9474 33.592 31.2014 32.8416Z",
    fill: "#0E0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5985 2.01124C45.8223 6.59901 46.0456 11.1868 46.2694 15.7753C46.2694 16.8262 47.165 17.6376 48.2094 17.5865C49.2538 17.5346 49.9993 16.6401 49.9993 15.5885C49.7755 10.9931 49.5522 6.39845 49.3284 1.80381C49.2538 0.752954 48.3585 -0.053109 47.3141 0.00408564C46.3443 0.0612803 45.5239 0.961145 45.5985 2.01124Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacySystemTaxVector);
export default __webpack_public_path__ + "static/media/LegacySystemTax-vector.2fb564d785a3c4e3970f74463b1da8d6.svg";
export { ForwardRef as ReactComponent };